import { Outlet, Navigate } from "react-router-dom";
import { Globe, Mail, Clock, Link2, Box, Radio, Film, HardDrive, FileText, Database, ShieldCheck, Monitor, Activity } from "lucide-react";
import SettingsSectionNav from "../../components/Settings/SettingsSectionNav";
import ROUTES from "../../router/routes";

const CONFIG_NAV = [
  { path: ROUTES.SETTINGS.CONFIG_GENERAL,   label: "General",     icon: Globe       },
  { path: ROUTES.SETTINGS.CONFIG_AUTH,      label: "Auth",        icon: ShieldCheck },
  { path: ROUTES.SETTINGS.CONFIG_EMAIL,     label: "Email",       icon: Mail      },
  { path: ROUTES.SETTINGS.CONFIG_SCHEDULER, label: "Scheduler",   icon: Clock     },
  { path: ROUTES.SETTINGS.CONFIG_GLUON,     label: "Gluon Link",  icon: Link2     },
  { path: ROUTES.SETTINGS.CONFIG_SANDBOX,   label: "Sandbox",     icon: Box       },
  { path: ROUTES.SETTINGS.CONFIG_REALTIME,  label: "Realtime",       icon: Radio     },
  { path: ROUTES.SETTINGS.CONFIG_DESKTOP,   label: "Desktop Bridge", icon: Monitor   },
  { path: ROUTES.SETTINGS.CONFIG_STORAGE,   label: "Storage",        icon: HardDrive },
  { path: ROUTES.SETTINGS.CONFIG_MEDIA,     label: "Media",       icon: Film      },
  { path: ROUTES.SETTINGS.CONFIG_LOGGING,   label: "Logging",     icon: FileText  },
  { path: ROUTES.SETTINGS.CONFIG_CACHE,     label: "Cache",       icon: Database  },
  { path: ROUTES.SETTINGS.CONFIG_TELEMETRY, label: "Telemetry",   icon: Activity  },
];

const ConfigLayout = () => (
  <div className="flex w-full h-full">
    {/* Left nav — visible on md+ */}
    <div className="hidden md:flex flex-col w-52 flex-shrink-0 border-r border-edge-gray-200 dark:border-edge-dialog-border pt-5 pb-6 px-3 gap-1">
      <p className="text-[11px] font-semibold uppercase tracking-wider text-ink-gray-400 dark:text-ink-gray-500 px-3 mb-2">
        Configuration
      </p>
      <SettingsSectionNav items={CONFIG_NAV} />
    </div>

    {/* Main content */}
    <div className="flex-1 min-w-0 overflow-hidden">
      <Outlet />
    </div>
  </div>
);

export const ConfigIndexRedirect = () => (
  <Navigate to={ROUTES.SETTINGS.CONFIG_GENERAL} replace />
);

export default ConfigLayout;
